import * as Redux from 'redux';
import * as Bixby from './../../core';
import {
  DraftState,
  DraftActionTypes,
  DRAFT_LOADING,
  DRAFT_FAILURE,
  UPDATE_DRAFT_FAILURE,
  UPDATE_DRAFT_INPROGRESS,
  UPDATE_DRAFT_SUCCESS,
  CREATE_DRAFT_FAILURE,
  CREATE_DRAFT_INPROGRESS,
  CREATE_DRAFT_SUCCESS,
  SET_DRAFT_COMPANY,
  DELETE_DRAFT_INPROGRESS,
  DELETE_DRAFT_FAILURE,
  DELETE_DRAFT_SUCCESS,
  PUBLISH_DRAFT_FAILURE,
  PUBLISH_DRAFT_INPROGRESS,
  PUBLISH_DRAFT_SUCCESS,
  SET_DRAFT_INPROGRESS,
  SET_DISCARD_DRAFT,
} from './types';
import { LOGIN_CLEAR_PRELOADED_DATA } from '$/store/login/types';

const initialState: DraftState = {
  isLoading: false,
  error: undefined,
  draftCompany: undefined,
  isEditing: false,
  discardDraft: false,
};

const draftReducer: Redux.Reducer<DraftState> = (state = initialState, action: DraftActionTypes): DraftState => {
  switch (action.type) {
    case LOGIN_CLEAR_PRELOADED_DATA:
      return initialState;
    case SET_DRAFT_COMPANY:
      return {
        ...state,
        draftCompany: action.payload as Bixby.Models.DraftCompany,
        discardDraft: false,
        isLoading: false,
      };
    case SET_DRAFT_INPROGRESS:
      return {
        ...state,
        isEditing: action.payload as boolean,
        discardDraft: false,
      };
    case SET_DISCARD_DRAFT:
      return {
        ...state,
        discardDraft: action.payload as boolean,
      };
    case DRAFT_LOADING:
    case UPDATE_DRAFT_INPROGRESS:
    case CREATE_DRAFT_INPROGRESS:
    case DELETE_DRAFT_INPROGRESS:
    case PUBLISH_DRAFT_INPROGRESS:
      return {
        ...state,
        isLoading: true,
        discardDraft: false,
      };
    case DRAFT_FAILURE:
    case CREATE_DRAFT_FAILURE:
      return {
        ...state,
        error: action.payload as Bixby.Models.BixbyError,
        draftCompany: undefined,
        discardDraft: false,
        isLoading: false,
      };
    case UPDATE_DRAFT_FAILURE:
    case DELETE_DRAFT_FAILURE:
    case PUBLISH_DRAFT_FAILURE:
      return {
        ...state,
        error: action.payload as Bixby.Models.BixbyError,
        discardDraft: false,
        isLoading: false,
      };
    case UPDATE_DRAFT_SUCCESS:
    case CREATE_DRAFT_SUCCESS:
    case DELETE_DRAFT_SUCCESS:
      return {
        ...state,
        discardDraft: false,
        isLoading: false,
      };
    case PUBLISH_DRAFT_SUCCESS:
      return {
        ...state,
        discardDraft: false,
        isLoading: false,
        draftCompany: undefined,
      };
    default:
      return state;
  }
};

export default draftReducer;
